import { useLocation, useNavigate } from 'react-router-dom';
import { Navbar } from '../components/micro/NavBar/NavBar';
import './DetailBlog.scss';
import moment from 'moment';
import { usePortContext } from '../service/MessageChannelContext';
import { InsightList } from '../components/micro/InsightList/InsightList';
import { useEffect, useState } from 'react';

const content = {
  postedBy: {
    en: 'Posted by',
    id: 'Ditulis oleh',
  },
};

const DetailBlog = () => {
  const { state: insight } = useLocation();
  const { lang, historyData } = usePortContext();
  const navigate = useNavigate();
  const [insights, setInsights] = useState([]);
  useEffect(() => {
    if (historyData) {
      setInsights(historyData?.insights.filter((i) => i.title !== insight.title));
    }
  }, [historyData, lang, insight]);

  return (
    <div className="detail-blog">
      <Navbar pinned rightButtonIcon={null} logo="" leftButtonAction={() => navigate('/mySkinDiary')} />
      <img src={insight?.imageUrl} alt={insight?.title} className="insight-img" />
      <div className="detail-title">{insight?.title}</div>
      <div className="detail-date">
        {`${moment(insight?.date).format('MM/YYYY')} ${content.postedBy[lang]} `}
        <span>{insight?.author}</span>
      </div>
      <div className="detail-content">{insight?.content}</div>
      <div className="detail-footer"> *** </div>
      <InsightList insights={insights} onClick={(insight) => navigate('/detailBlog', { state: insight })} />
    </div>
  );
};

export default DetailBlog;
